// extracted by mini-css-extract-plugin
export default {"account-card":"AccountCard_account-card__vHf6P","emoji":"AccountCard_emoji__tkhC7"};